import React from 'react';
import Emoji from 'react-emoji-render';

const EmojiAvatar = ({ code, onClick, selected, isClickable }) => {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      className={`h-full w-full rounded-full bg-white flex justify-center items-center cursor-default shadow-md transition-colors ${
        selected ? 'border-2 border-solid border-indigo-500' : ''
      } ${isClickable ? 'cursor-pointer hover:bg-slate-50' : ''} `}
      onClick={onClick}>
      <Emoji text={code} className="[&>span]:text-[28px]" />
    </div>
  );
};

export default EmojiAvatar;
